import { IModelEntity } from '@pit/core';
import { IDtoAddress } from './dto.address.interface';
import { ShipmentDeliveryType, ShipmentProcessState } from './dto.shipment.process.interface';
import { ShipmentDeliveredTo, ShipmentDeliveredToConfirmation } from './dto.shipment.process.recipient.interface';

export interface IDtoArchive extends IModelEntity {

    depotNumber?: string;
    deviceId?: string;
    externalShipmentId?: string;
    shipmentNumbers?: string[];
    timestamp?: Date;
    userName?: string;

    productTypeCode?: string;
    productTypeDescription?: string;

    customerNumber?: string;
    customerName?: string;
    customerCostCenterCode?: string;

    addresseeCity?: string;
    addresseeZipCode?: string;
    addresseeStreet?: string;
    addresseeHouseNumber?: string;
    addresseeName1?: string;
    addresseeName2?: string;
    addresseeName3?: string;

    processState?: ShipmentProcessState;
    deliveredTo?: ShipmentDeliveredTo;
    deliveredToConfirmation?: ShipmentDeliveredToConfirmation;
    deliveryAddressName?: string;
    deliveryAddressStreet?: string;
    deliveryAddressHouseNumber?: string;
    deliveryAddressZipCode?: string;
    deliveryAddressCity?: string;
    deliverySignature?: string;
    shipmentPhoto?: string;
    deliveryType?: ShipmentDeliveryType;
    returnCode?: string;
    returnCodeDescription?: string;

    latitude?: number;
    longitude?: number;

    fullAddressee?: string;
    fullAddresseAdress?: string;
    fullAddresseeName?: string;

    fullDeliveryAddress?: string;

}
